import DocumentView from "./DocumentView";

export default DocumentView;



// WEBPACK FOOTER //
// ./src/components/DocumentV2/DocumentView/index.js